import { ApiResponse, apiCall } from "./apiClient";
import { GeofenceDto, SaveGeofenceDto } from "../models/geofence/geofence";

export const getGeofences = (
    customerId?: string,
    costCenterId?: string,
    signal?: AbortSignal
): Promise<ApiResponse<GeofenceDto[]>> => {
    const params: Record<string, string> = {};
    if (customerId) params.customerId = customerId;
    if (costCenterId) params.costCenterId = costCenterId;
    return apiCall<GeofenceDto[]>("geofences", "GET", params, signal);
};

export const createGeofence = (
    dto: SaveGeofenceDto,
    signal?: AbortSignal
): Promise<ApiResponse<GeofenceDto>> => {
    return apiCall<GeofenceDto>("geofences", "POST", dto, signal);
};

export const updateGeofence = (
    geofenceId: string,
    dto: SaveGeofenceDto,
    signal?: AbortSignal
): Promise<ApiResponse<GeofenceDto>> => {
    return apiCall<GeofenceDto>(`geofences/${geofenceId}`, "PUT", dto, signal);
};

export const deleteGeofence = (
    geofenceId: string,
    signal?: AbortSignal
): Promise<ApiResponse<void>> => {
    return apiCall<void>(`geofences/${geofenceId}`, "DELETE", null, signal);
};
